import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useDidMountEffect from 'assets/js/useDidMountEffect';

/* MODAL */
import { useModal } from 'hooks/modalContext';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* 컴포넌트 */
import Pagination from 'components/util/Pagination';

const ManageCapture = () => {
  const { openModal } = useModal();

  const [offset, setOffset] = useState(0);
  const [manageCapture, setManageCapture] = useState({
    pageNum: 0,
    count: 0,
    offset: 0,
    list: [],
    isData: true,
  });

  useEffect(() => {
    Common.isLogin();

    getManageCaptureListCount();
  }, []);

  useDidMountEffect(() => {
    getManageCaptureListCount();
  }, [offset]);

  useDidMountEffect(() => {
    if (!manageCapture.isData) {
      Server.sendGet('client/manage/capture', {
        limit: 11,
        offset: offset * 5,
      }, getManageCaptureListCallback).then();
    }
  }, [manageCapture]);

  const getManageCaptureListCount = () => {
    Server.sendGet('client/manage/capture/count', {}, getManageCaptureListCountCallback).then();
  };

  const getManageCaptureListCountCallback = res => {
    setManageCapture(() => {
      return {
        ...manageCapture,
        pageNum: Math.ceil(res['resultCount'] / 11),
        count: res['resultCount'],
        offset: offset,
        isData: false,
      };
    });
  };

  const getManageCaptureListCallback = res => {
    setManageCapture(() => {
      return {
        ...manageCapture,
        list: res['resultList'],
        isData: true,
      };
    });
  };

  const onSearch = res => {
    setOffset(res);
  };

  const handleAdd = () => {
    openModal({
      modalName: 'ManageCaptureModal',
      modalData: {
        isRegi: true,
        data: {
          item: {},
          callback: null,
        },
      }
    });
  };

  const handleContent = item => {
    openModal({
      modalName: 'ManageCaptureModal',
      modalData: {
        isRegi: false,
        data: {
          item: item,
          callback: null,
        },
      }
    });
  };

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Manage Client Capture</h4>
          </TitHead>
          <BtnDesc>
            <TitBtn onClick={handleAdd}>
              <Ic src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/add_ic.svg'/>
              <span>Manage Capture Data</span>
            </TitBtn>
          </BtnDesc>
        </Title>
        <Content>
          <Table>
            <colgroup>
              <col width='20%'/>
              <col width='50%'/>
              <col width='30%'/>
            </colgroup>
            <thead>
            <tr>
              <th>Date</th>
              <th>Client</th>
              <th>detail</th>
            </tr>
            </thead>
            <tbody>
            {manageCapture?.list.map((item, idx) => (
              <tr key={idx}>
                <td>{item.regDate}</td>
                <td>{item.clientName}</td>
                <td>
                  <TitBtn onClick={() => handleContent(item)}>
                    <span>Detail</span>
                  </TitBtn>
                </td>
              </tr>
            ))}
            {Common.isEmpty(manageCapture) &&
              <tr>
                <td colSpan={3} className={'none-data'}>
                  There is no data to output.
                </td>
              </tr>
            }
            </tbody>
          </Table>
        </Content>

        <Pagination data={manageCapture} offset={offset} search={onSearch}/>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const BtnDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;
`;

const TitBtn = styled.button`
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 0 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  border-radius: 5px;
  margin: auto;

  & span {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

const Ic = styled.img.attrs({ alt: 'Util Icon' })``;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 701px;
  overflow-y: scroll;
`;

const Table = styled.table`
  position: relative;

  & th {
    padding: 15px 0;
    font-weight: 400;
    font-size: 18px;
    color: #777777;
    background: #f8f8f8;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    vertical-align: middle;
  }

  & td {
    padding: 10px 0;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: center;
    vertical-align: middle;
    border-bottom: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;
  }

  & thead {
    position: sticky;
    top: 0;
  }

  & tbody > tr {
    cursor: pointer;

    &:hover {
      & td {
        background: #f4f4f4;
      }
    }
  }

  & tr td.none-data {
    height: 572px;
    border: 0;
  }

  & tr td:first-child {
    border-left: none;
  }

  & tr:nth-child(even) {
    background: #fcfcfc;
  }
`;

export default ManageCapture;